import { createAsyncThunk } from '@reduxjs/toolkit'
import Team from './team-model'
import { delete_team, load_teams, store_team } from './team-service'

export const LoadTeamsAsync = createAsyncThunk<any, any>(
  'composer/load/team',
  async (params: { uid: string }) => {
    return await load_teams(params)
  },
)

export const CreateTeamAsync = createAsyncThunk<any, any>(
  'composer/create/team',
  async (params: Team) => {
    return await store_team(params)
  },
)

export const DeleteTeamAsync = createAsyncThunk<any, any>(
  'composer/delete/team',
  async (params) => {
    return await delete_team(params)
  },
)
